<div class="form-group custom-form-group">
    <label *ngIf="heading" class="highlight">{{ heading }}</label>
    <input type="date" class="form-control custom-input" [ngClass]="{'is-invalid': !isValid}" [(ngModel)]="inputValue"
        [placeholder]="placeholder" [disabled]="isDisabled"
        (input)="onInputChange($event.target.value, $event.target.id)" [id]="id" [required]="isRequired"
        (click)="openDatePicker($event)">
    <p *ngIf="hint" class="form-text text-muted">{{ hint }}</p>
    <span [id]="id + '_span'" class="required" style="display: none;"> * This field is required</span>
    <div *ngIf="!isValid" class="invalid-feedback">Input date must be between {{ minWords }} and {{ maxWords }} </div>
</div>